import { render } from "./DescriptionComponent.vue?vue&type=template&id=cfe2fc20&scoped=true"
import script from "./DescriptionComponent.vue?vue&type=script&lang=js"
export * from "./DescriptionComponent.vue?vue&type=script&lang=js"

import "./DescriptionComponent.vue?vue&type=style&index=0&id=cfe2fc20&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfe2fc20"]])

export default __exports__